import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "contestdream.photo.icon",
  "use": "contestdream.photo.icon-usage",
  "viewBox": "-3044.581 -14011.792 64.076 83.534",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3044.581 -14011.792 64.076 83.534\" id=\"contestdream.photo.icon\"><defs><style>#contestdream.photo.icon .cls-1{fill:#46ccd5}</style></defs><g id=\"contestdream.photo.icon_Group_832\" data-name=\"Group 832\" transform=\"translate(-3044.581 -14011.792)\"><path id=\"contestdream.photo.icon_Subtraction_91\" data-name=\"Subtraction 91\" class=\"cls-1\" d=\"M64.076,83.534H0V0H64.076V83.533ZM3.019,2.684V80.85H61.056V2.684Z\" /><path id=\"contestdream.photo.icon_Path_208\" data-name=\"Path 208\" class=\"cls-1\" d=\"M3.221,30.981h0L19.932,0l12.18,22.389L43.728,11.127,63.314,36.772H0Z\" transform=\"rotate(-90 45.04 31.27)\" /><ellipse id=\"contestdream.photo.icon_Ellipse_12\" data-name=\"Ellipse 12\" class=\"cls-1\" cx=\"6.263\" cy=\"6.733\" rx=\"6.263\" ry=\"6.733\" transform=\"rotate(-90 17.732 3.798)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/contestdream.photo.icon.svg
// module id = zcq2
// module chunks = 13